import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo, useEffect, useRef, useState } from "react";
import { Box } from "./Box";
import { mergeSx } from "../system";
export const collapseClasses = {
    root: "MinervaCollapse-root",
};
export const Collapse = memo(({ expanded, sx, className, onTransitionEnd, ...rest }) => {
    const childRef = useRef(null);
    const [maxHeight, setMaxHeight] = useState("0");
    useEffect(() => {
        const calculateHeight = () => {
            if (expanded && childRef.current) {
                setMaxHeight(`${childRef.current.scrollHeight}px`);
            }
            else {
                setMaxHeight("0");
            }
        };
        // Calculate the initial height
        calculateHeight();
        const mutationObserver = new MutationObserver(calculateHeight);
        if (childRef.current) {
            mutationObserver.observe(childRef.current, {
                childList: true,
                subtree: true,
            });
        }
        return () => {
            mutationObserver.disconnect();
        };
    }, [expanded]);
    return (_jsx(Box, { ref: childRef, onTransitionEnd: (e) => {
            if (expanded) {
                setMaxHeight("none");
            }
            onTransitionEnd?.(e);
        }, className: clsx([collapseClasses.root, className]), sx: mergeSx({
            maxHeight: maxHeight,
            overflow: "hidden",
            transition: "max-height 0.2s ease-in-out",
        }, sx), ...rest }));
});
//# sourceMappingURL=Collapse.js.map